// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"legal_mainContent__17KuI","textContent":"legal_textContent__3Zq7T","title":"legal_title__26Dwp"};